import React from 'react';
import './ResultContent.scss';
import {Button, ButtonVariant} from '@ael/shared-components-library';
import {Score} from './Score';
import {FormattedMessage, MessageDescriptor} from 'react-intl';
import {quizMessages} from '../../../../../translates/quizMessages';

interface ResultContentProps {
  successful: number;
  total: number;
  successRate: number | null;

  onClose: (passed: boolean) => void;
}

const getResultLabel = (testFailed: boolean, successRate: ResultContentProps['successRate']): MessageDescriptor => {
  if (testFailed) {
    return quizMessages.failMessage;
  }

  return successRate === null ? quizMessages.successMessage : quizMessages.passedMessage;
};

export const ResultContent: React.FC<ResultContentProps> = ({ successful, total, successRate, onClose }) => {
  const score = (successful / total) * 100;
  const testFailed = successRate !== null && score < successRate;

  return (
    <div className="result">
      <div className="result__pane">
        <div className="result__label">
          <FormattedMessage {...getResultLabel(testFailed, successRate)} />
        </div>
        <div className="result__explanation">
          {testFailed && (
            <div>
              <FormattedMessage {...quizMessages.scoreBelowSuccessRate} values={{ successRate: successRate }} />
            </div>
          )}
          <div>
            <FormattedMessage {...quizMessages.scoreExplanation} />
          </div>
        </div>
        <div className="result__score">
          <Score successRate={successRate} scoreInPercentage={score} successful={successful} total={total} />
        </div>
        <div className="result__footer">
          <Button variant={ButtonVariant.SUCCESS} onClick={() => onClose(!testFailed)}>
            <FormattedMessage {...quizMessages.close} />
          </Button>
        </div>
      </div>
    </div>
  );
};
